import React from "react";
import { useParams } from "react-router-dom";
import { useWhiteLabel } from "@lib/context";
import { AppContext } from "@lib/types/Context";
import { SharedBlockchainPaymentList } from "@app/shared";
import { NoPermission } from "@lib/components/AppComponents";

const CustomerBlockchainPaymentList: React.FC = () => {
  const { customerId } = useParams();
  const { permissions } = useWhiteLabel();

  // Check if user has permission to view wallet pool
  if (!permissions.canViewWalletPool) {
    return <NoPermission />;
  }

  return (
    <SharedBlockchainPaymentList
      context={AppContext.CUSTOMER}
      customerId={customerId}
    />
  );
};

export default CustomerBlockchainPaymentList;
